/**
 * MSI3-host signed-in landing destination.
 * Active only when isMsi3Host(). Keys off faculty grant doc (hasGrant), not
 * isFaculty (admins without a grant go to AcuityDrill).
 */
import { useMsi3FacultyGrant } from "./msi3FacultyGrant";
import {
  isMsi3Host,
  msi3SignedInLandingPath,
} from "./msi3HostRouting";

/**
 * @param {{ enabled?: boolean }} [options]
 *   When false, skips the grant read (e.g. explicit ?next= deep link).
 * @returns {{
 *   active: boolean,
 *   loading: boolean,
 *   path: string | null,
 * }}
 */
export function useMsi3SignedInLanding({ enabled = true } = {}) {
  const active = Boolean(enabled && isMsi3Host());
  const { loading, hasGrant } = useMsi3FacultyGrant({ enabled: active });

  if (!active) {
    return { active: false, loading: false, path: null };
  }

  return {
    active: true,
    loading,
    path: loading ? null : msi3SignedInLandingPath({ hasGrant }),
  };
}

export default useMsi3SignedInLanding;
